const highlightClass = "google-maps-offers--i_highlighted"
const animateClass = "google-maps-offers--i_animated"

// This controller is responsible for logic related to individual search map cards:
// 1. Interacting with an individual card.
// 2. Pushing the related map marker HTML when the card is shown.
stimulusApp.register(
  "search-map-card",
  class extends Stimulus.Controller {
    static targets = ["marker", "card"]
    static values = {
      id: Number,
      scrollContainerSelector: String,
    }

    connect() {
      if (this.hasScrollContainerSelectorValue) {
        this.element.addEventListener("hb:focus", this.focus)
      } else {
        console.warn(
          "WARNING: Define scrollContainerSelector value on:",
          this.element,
        )
      }
    }

    markerTargetConnected(_) {
      this.pushMarkerToMap()
    }

    selectOnce(event) {
      if (HB.mapHelpers.selectedMarkerId() != this.idValue) {
        event?.preventDefault()
        this.select()
      }
    }

    show() {
      if (this.element.hidden) {
        this.element.hidden = false
        requestAnimationFrame(() => {
          this.pushMarkerToMap()
        })
      }
    }

    hide(sequence) {
      if (!this.element.hidden) {
        this.element.dataset.hiddenSequence = sequence
      }
      this.element.hidden = true
    }

    select = (_) => {
      this.highlight()
      HB.mapHelpers.selectMarkerById(this.idValue)
    }

    deselect = (_) => {
      this.element.classList.remove(highlightClass)
      HB.mapHelpers.deselectMarkerById(this.idValue)
    }

    focus = (_) => {
      if (Detector.isDesktop) {
        this.focusing = true

        Viewport.scrollTo(jQuery(this.element), {
          containerSelector: this.scrollContainerSelectorValue,
          offset: this.scrollContainerDistanceToLeftEdge() == 0 ? -10 : 0,
          callback: () => {
            this.element.classList.remove(animateClass)
            requestAnimationFrame(() => {
              this.focusing = false
              this.highlight()
              this.element.classList.add(animateClass)
            })
          },
        })
      } else {
        requestAnimationFrame(() => {
          this.highlight()
          if (HB.mapHelpers.markerSelectedOnce()) {
            this.element.classList.add(animateClass)
          }
        })
      }
    }

    isHighlighted = () => {
      return this.element.classList.contains(highlightClass)
    }

    highlight = () => {
      document.querySelectorAll("." + highlightClass).forEach((el) => {
        el.classList.remove(highlightClass, animateClass)
      })
      this.element.classList.add(highlightClass)
    }

    unHighlight = () => {
      this.element.classList.remove(highlightClass, animateClass)
    }

    pushMarkerToMap = () => {
      let mapMarker = HB.mapHelpers.getMarkerById(this.idValue)
      if (mapMarker && this.markerTarget) {
        mapMarker.setContent(this.markerTarget.innerHTML)
        if (this.markerTarget.dataset.markerClass) {
          mapMarker.addContainerClass(this.markerTarget.dataset.markerClass)
        }
      }
    }

    scrollContainerDistanceToLeftEdge = () => {
      return document
        .querySelector(this.scrollContainerSelectorValue)
        .getBoundingClientRect().left
    }
  },
)
